<!-- 旗舰话费 -->
<template>
  <div>

    <!-- 图片标题 -->
    <div class="">
      <div class="pannel-pay-title">
        <img v-if="orderInfo.payType=='tbalip'" src="/imgs/title_zfb.jpg" />
      </div>
    </div>

    <!-- 订单号 -->
    <OrderIdComp :order-info="orderInfo" />

    <!-- 强制说明 -->
    <div class="pannel pannel-center">
      <div class="pay-flow" style="color:yellow; background-color: #4052B6;">
        <p class="no">骚扰机主，全平台将封禁游戏号和手机！</p>
      </div>
    </div>

    <!-- 付款流程 -->
    <div class="pannel">
      <div class="pay-flow" v-if="orderInfo.payType=='weixin'">
        <p style="color: #4CAF50;"><b>付款流程：</b></p>
        <p class="no">1、<span style="color:red;">手动</span>打开微信APP</p>
        <p class="no">2、<span style="color:red;">我->服务->手机充值</span>点击进入；</p>
        <p class="no">3、长按手机号码输入框，<span style="color:red;">粘贴充值号码</span></p>
        <p class="no">4、<span style="color:red;">请勿复制手机号码转账到微信，否则不会到账，无法追回</span></p>
      </div>
      <div class="pay-flow" v-if="orderInfo.payType=='alipay'">
        <p style="color: #4CAF50;"><b>付款流程：</b></p>
        <p class="no">1、<span style="color:red;">手动</span>打开支付宝APP</p>
        <p class="no">2、首页选择<span style="color:red;">手机充值功能</span></p>
        <p class="no">3、长按手机号码输入框，<span style="color:red;">粘贴充值号码</span></p>
        <p class="no">4、<span style="color:red;">请勿复制手机号码转账到支付宝，否则不会到账，无法追回</span></p>
      </div>
      <div class="pay-flow" v-if="orderInfo.payType=='douyin'">
        <p style="color: #4CAF50;"><b>付款流程：</b></p>
        <p class="no">1、<span style="color:red;">手动</span>打开抖音APP</p>
        <p class="no">2、我-右上角“≡”-我的钱包<span style="color:red;">手机充值</span>功能</p>
        <p class="no">3、长按手机号码输入框,<span style="color:red;">粘贴充值号码</span></p>
        <p class="no">4、<span style="color:red;">请勿复制手机号码转账到抖音，否则不会到账，无法追回</span></p>
      </div>
    </div>

    <!-- 倒计时 -->
    <TimerComp2 :order-info="orderInfo" :pay-time-info="payTimeInfo" />

    <!-- 支付链接 -->
    <div class="pannel" style="">
      <table class="details" style="">
        <tr>
          <td>支付链接</td>
          <td>
            <span v-if="copyPayUrlIf" style="color: green;">已复制</span>
            <button @click="copyPayUrl" class="btn copy">复制链接</button>
          </td>
        </tr>
        <tr>
          <td colspan="2" style="text-align:center;">
            <div style="font-size: 0.75em;">
              <p style="color: red;">如果复制不到链接，请手动复制下面框内链接</p>
            </div>
          </td>
        </tr>
        <tr>
          <td colspan="2" style="text-align:center;">
            <textarea style="border:1;background-color:rgba(241,241,241,.98);width:94%;height:100px;padding:5px;" readonly v-model="payUrl"></textarea>
          </td>
        </tr>
      </table>
    </div>

    <!--抖音唤醒按钮-->
    <div class="pannel-btn" v-if="orderInfo.orderId&&orderInfo.payType=='douyin'">
      <div v-if="orderInfo.payType=='douyin'">
        <a href="snssdk1128://" class="btn btn-alip" style="width:70%;">快速打开抖音</a>
      </div>
    </div>

    <!-- time tips -->
    <TimeTipsComp :order-info="orderInfo" />

    <!--演示视频-->
    <div class="pannel-simp title" v-if="orderInfo.payType=='douyin'">
      <div style="text-align:center;" v-if="orderInfo.payType=='douyin' && showVideo">
        <img v-if="orderInfo.payType=='douyin'" src="/imgs/douyin01.gif" />
      </div>
      <div class="">
        <button class="btn video" style="width:80%;" @click="showVideo=!showVideo" v-if="!showVideo">显示支付流程视频</button>
      </div>
    </div>

    <!-- 警告事项 -->
    <div class="pannel-simp attention">
      <p class="">
        <span style="color:#4CAF50;"><b>注意</b></span>：<span style="color: red;">超时支付，修改金额，修改支付方式，重复支付，</span>无法追回!!!
      </p>
      <p class="">
        <span style="color:#4CAF50;"><b>注意</b></span>：<span style="color: red;">次日前未查，</span>无法追回!!!
      </p>
      <p class="">
        <span style="color:#4CAF50;"><b>注意</b></span>：支付成功确认时间<span style="color: red;">5-10分钟</span>,付款后<span style="color: red;">超过10分钟</span>还未到账,请联系客服查单补单!
      </p>
    </div>

  </div>
</template>

<script>
import "@/styles/shanshuo.css"; //
import OrderIdComp from "@/views/comp/slot_order_id_comp";
import TimerComp2 from "@/views/comp/slot_timer_comp2";
import TimeTipsComp from "@/views/comp/slot_time_tips_comp";
export default {
  components: {
    OrderIdComp,
    TimerComp2,
    TimeTipsComp,
  },
  props: {
    orderInfo: {
      type: Object,
      default() {
        return {};
      },
    },
    payTimeInfo: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      // 复制相关
      copyPayUrlIf: false,
      //
      payUrl: "",
    };
  },
  computed: {},
  created() {
    console.log(this.orderInfo);
    this.payUrl = this.orderInfo.payUrl;
    window.location.href = this.orderInfo.payUrl;
  },
  methods: {
    //
    initUrl() {
      console.log(this.orderInfo);
      //this.payUrl = this.orderInfo.payUrl;
    },
    // 复制手机
    copyPayUrl: function () {
      this.$parent.$parent.copySome(
        this.orderInfo.payUrl,
        1,
        () => {
          this.copyPayUrlIf = true;
        },
        // eslint-disable-next-line
        (err) => {
          this.$parent.$parent.copyErr();
        }
      );
    },
  },
};
</script>

<style lang="scss">
</style>

<style lang="scss" scoped>
</style>
